import { CheckInStatusEnum } from 'app/shared/enums/check-in-status-type.enum';
import { LocationTypeEnum } from 'app/shared/enums/location-type.enum';
import { HttpBasicRequest } from 'app/shared/models/http-basic-request.model';
import { Shop } from 'app/shared/models/shop.model';
import { VatPrefixEnum } from '../enum/vat-prefix.enum.model';
import { ContactVM } from '../models/back-office-admin-common/contact.models';
import { ICompanyForm, PaymentTermDto, CustomerCheckinVM, VatPrefix, CustomerDiscountDTO, CompanyInfoVM } from '../models/back-office-admin-common/customer-check-in.model';
import { RegisterCustomerVM, CustomerRegistrationPOS } from '../models/customer/customer-registration.model';
import { BlockOrderTypeEnum, CustomerFullDTO, CustomerUpdateDto, CustomerVM, CustomerVMWhenCheck, CustomerVoucherVM } from '../models/customer/customer.model';
import { LocationFullDTO } from '../../../shared/models/location.model';
import { PointOfSaleDetailVM } from '../models/point-of-sale/bo-point-of-sale.model';
import { ContactMapper } from './contact-mapper';
import { LocationMapper } from './location-mapper';
import { LocationCustomerDTO } from '../models/customer/customer-location.model';
import { CustomerCategoryDTO } from 'app/shared/models/customer-category.model';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { PaymentTermsByChannelDTO } from '../models/back-office-admin-common/channel-payment-term.model';
import { CustomerStatusTypeEnum } from 'app/shared/enums/customer-status-type.enum';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidator } from 'app/shared/utilities/custom-validators.models';

export class CustomerMapper {

  public static CustomerCheckin(customer: CustomerFullDTO, categoriesDTO: CustomerCategoryDTO[], billingLocation: LocationCustomerDTO, formsDTO: ICompanyForm[], listPaymentTerms: PaymentTermDto[]): CustomerCheckinVM {

    const vatPrefix = this.checkVatPrefix(customer.vatNumber);
    const vat = vatPrefix ? customer.vatNumber.replace(vatPrefix, '')?.trim() : customer.vatNumber;
    const customerCheckin = new CustomerCheckinVM({
      companyInfo: new CompanyInfoVM({
        lastModificationTime: customer.lastModificationTime,
        creationTime: customer.creationTime,
        checkInStatus: customer.checkInStatus,
        customerCategories: categoriesDTO,
        customerSelectedCategories: customer.customerCategories,
        customerType: customer.customerType,
        externalId: customer.externalId,
        fiscalCode: customer.fiscalCode,
        id: customer.id,
        listCompanyForm: formsDTO,
        location: billingLocation?.location ?? new LocationFullDTO(),
        name: customer.name,
        vatNumber: vat,
        vatPrefix: vatPrefix || null,
        listVatPrefix: this.GetListVatPrefix(),
        companyFormId: customer.companyFormId,
        paCode: customer.paCode,
        pecEmail: customer.pecEmail,
        sdiCode: customer.sdiCode,
        creatorId: customer.creatorId,
        lastModifierId: customer.lastModifierId,
        formGroup: new FormGroup({
          vatNumber: new FormControl({ value: vat || '', disabled: true }),
          fiscalCode: new FormControl(customer.fiscalCode),
          name: new FormControl(customer.name, Validators.required),
          customerCategories: new FormControl(''),
          companyForm: new FormControl(''),
          vatPrefix: new FormControl(''),
          // companyType: new FormControl('', Validators.required),
          sdiCode: new FormControl(customer.sdiCode, [Validators.maxLength(7), Validators.pattern('^[a-zA-Z0-9_.-]*$'), Validators.minLength(7)]),
          paCode: new FormControl(customer.paCode, [Validators.maxLength(6), Validators.pattern('^[a-zA-Z0-9_.-]*$'), Validators.minLength(6)]),
          pecEmail: new FormControl(customer.pecEmail, [CustomValidator.email()]),
        }, [CustomValidator.checkOnlyProp1OrProp2('sdiCode', 'paCode', 'sdiCodeOrPaCode')])
      }),
      paymentInfo: {
        abi: customer.abi,
        cab: customer.cab,
        listPaymentTerm: listPaymentTerms,
        paymentTermId: customer.paymentTermId,
        swift: customer.swift,
        paymentTermOverrides: customer.paymentTermOverrides.map(x => new PaymentTermsByChannelDTO({
          channel: x.channel,
          paymentTermId: x.paymentTermId,
          paymentTerm: x.paymentTerm,
          channelId: x.channel.id,
          id: x.id,
        })),
      },
      contactInfo: billingLocation?.contacts,
      // contactInfo: ContactMapper.mapContact(billingLocation?.contacts),
      companyFinancialStatus: {
        graphReport: 0,
        isActiveEnterprise: customer.isActiveEnterprise,
        isCompliantActivity: customer.isCompliantActivity,
        isCorrectRegistry: customer.isCorrectRegistry
      },
      commercialBlock: {
        isCommercialBlock: !customer.acceptsOrders,
        ordersBlockedByUser: customer.ordersBlockedByUser,
      },
    });


    return customerCheckin;
  }

  public static GetListVatPrefix(): VatPrefix[] {
    return Object.keys(VatPrefixEnum).map((key) => {
      return {
        name: (VatPrefixEnum[key] ? (VatPrefixEnum[key] + ' - ') : '') + key.split(/(?=[A-Z])/).toString().replace(',', ' '),
        code: VatPrefixEnum[key],
      };
    });
  }

  private static checkVatPrefix(vatNumber: string): string {
    let result: string;
    let vatPrefix = null;
    var splitted = vatNumber?.split(' ');
    splitted?.length > 1 ?
      vatPrefix = splitted[0]?.trim() :
      vatPrefix = vatNumber?.substring(0, 2);
    if (vatPrefix)
      Object.keys(VatPrefixEnum).forEach(key => {
        if (VatPrefixEnum[key] === vatPrefix.toUpperCase()) {
          result = VatPrefixEnum[key];
        }
      });
    return result;
  }

  public static CustomerDTO(checkInData: CustomerCheckinVM, checkInStatus: CheckInStatusEnum, notUsePrefix: boolean = false, removeSpace?: boolean): CustomerFullDTO {
    let vat = checkInData.companyInfo.vatNumber ? (checkInData.companyInfo.vatPrefix && !notUsePrefix) ? checkInData.companyInfo.vatPrefix + " " + checkInData.companyInfo.vatNumber?.replace(/ /g, '') : checkInData.companyInfo.vatNumber?.replace(/ /g, '') : null;
    if (removeSpace) vat = vat?.replace(/ /g, '');
    return new CustomerFullDTO({
      isActiveEnterprise: checkInData.companyFinancialStatus.isActiveEnterprise,
      isCompliantActivity: checkInData.companyFinancialStatus.isCompliantActivity,
      isCorrectRegistry: checkInData.companyFinancialStatus.isCorrectRegistry,
      abi: checkInData.paymentInfo.abi,
      availableAllowance: '',
      basicCardId: null,
      cab: checkInData.paymentInfo.cab,
      checkInStatus: checkInStatus,
      companyFormId: checkInData.companyInfo.companyFormId,
      customerType: checkInData.companyInfo.customerType,
      externalId: checkInData.companyInfo.externalId,
      id: checkInData.companyInfo.id,
      name: checkInData.companyInfo.name,
      paCode: checkInData.companyInfo.paCode,
      pecEmail: checkInData.companyInfo.pecEmail,
      sdiCode: checkInData.companyInfo.sdiCode,
      swift: checkInData.paymentInfo.swift,
      vatNumber: vat,
      fiscalCode: checkInData.companyInfo.fiscalCode,
      acceptsOrders: !checkInData?.commercialBlock?.isCommercialBlock,
      paymentTermId: checkInData?.paymentInfo?.paymentTermId,
      blockOrderType: !checkInData?.commercialBlock?.isCommercialBlock ? BlockOrderTypeEnum.Unpaid : BlockOrderTypeEnum.Open
    });
  }

  public static CustomerUpdateDTO(customer: CustomerFullDTO): CustomerUpdateDto {
    return new CustomerUpdateDto({
      abi: customer.abi,
      acceptsOrders: customer.acceptsOrders,
      blockOrderType: customer.acceptsOrders ? BlockOrderTypeEnum.Open : BlockOrderTypeEnum.Unpaid,
      availableAllowance: customer.availableAllowance,
      basicCardId: customer.basicCardId,
      cab: customer.cab,
      checkInMessage: customer.checkInMessage,
      checkInStatus: customer.checkInStatus,
      commercialAllowance: customer.commercialAllowance,
      companyFormId: customer.companyFormId,
      customerType: customer.customerType,
      externalId: customer.externalId,
      fiscalCode: customer.fiscalCode,
      id: customer.id,
      name: customer.name,
      paCode: customer.paCode,
      pecEmail: customer.pecEmail,
      sdiCode: customer.sdiCode,
      swift: customer.swift,
      vatNumber: customer.vatNumber,
      paymentTermId: customer.paymentTermId,
      isActiveEnterprise: customer.isActiveEnterprise,
      isCompliantActivity: customer.isCompliantActivity,
      isCorrectRegistry: customer.isCorrectRegistry,
    });
  }

  public static companyCategoriesAddRequest(customerSelectedCategories: CustomerCategoryDTO[], cacheCustomerSelectedCategories: CustomerCategoryDTO[], companyId: Number, baseUrl: string,): HttpBasicRequest[] {
    const result: HttpBasicRequest[] = [];
    customerSelectedCategories?.filter((element1) => !cacheCustomerSelectedCategories.some(element2 => element1.id === element2.id)).forEach(categories => {
      result.push({ url: baseUrl + `/customers/${companyId}/customer-category/${categories.id}`, method: 'post' });
    });
    return result;
  }

  public static companyCategoriesRemoveRequest(customerSelectedCategories: CustomerCategoryDTO[], cacheCustomerSelectedCategories: CustomerCategoryDTO[], companyId: Number, baseUrl: string,): HttpBasicRequest[] {
    const result: HttpBasicRequest[] = [];
    cacheCustomerSelectedCategories?.filter((element1) => !customerSelectedCategories.some(element2 => element1.id === element2.id)).forEach(categories => {
      result.push({ url: baseUrl + `/customers/${companyId}/customer-category/${categories.id}`, method: 'delete' });
    });
    return result;
  }

  public static companyLocationUpdateRequest(customerLocation: LocationFullDTO, cacheCustomerLocation: LocationFullDTO, baseUrl: string,): HttpBasicRequest[] {
    const result: HttpBasicRequest[] = [];
    if (customerLocation !== cacheCustomerLocation) {
      result.push({ url: baseUrl + `/locations/${customerLocation.id}`, method: 'put', body: customerLocation },);
    }
    return result;
  }


  public static customerInfoCreateRequest(customer: CustomerFullDTO, baseUrl: string,): HttpBasicRequest[] {
    const result: HttpBasicRequest[] = [];
    result.push({ url: baseUrl + `/customers`, method: 'post', body: customer },);
    return result;
  }


  public static companyLocationCreateRequest(customerId: number, customerLocation: LocationFullDTO, baseUrl: string): HttpBasicRequest[] {
    const result: HttpBasicRequest[] = [];
    result.push({ url: baseUrl + `/customers/${customerId}/location`, method: 'post', body: { locationId: customerLocation.id, locationType: LocationTypeEnum.BillingLocation } });
    return result;
  }

  public static customerInfoUpdateRequest(customer: CustomerFullDTO, cacheCustomer: CustomerFullDTO, baseUrl: string,): HttpBasicRequest[] {
    const result: HttpBasicRequest[] = [];
    if (customer !== cacheCustomer) {
      result.push({ url: baseUrl + `/customers/${customer.id}`, method: 'put', body: this.CustomerUpdateDTO(customer) },);
    }
    return result;
  }

  public static customerDiscountsRequestHandler(current: CustomerDiscountDTO[] = [], cached: CustomerDiscountDTO[] = [], baseUrl: string): { putReqs: HttpBasicRequest[], postAndDelreqs: HttpBasicRequest[]; } {
    const toPost = current?.filter(x => !!x.discount && (!x.id || (!!x.id && cached.some(y => y.id === x.id && x.discount !== y.discount))))
      .map(x => this.postCustomerDiscount(x, baseUrl)) || [];
    const toDelete = current?.filter(x => !!x.id && !x.discount && cached.some(y => y.id === x.id && !!y.discount && !y.numOrders))
      .map(x => this.deleteCustomerDiscount(x, baseUrl)) || [];
    const updateLikeSoftDelete = current?.filter(x => !!x.id && cached.some(y => y.id === x.id && x.discount !== y.discount))
      .map(x => this.updateLikeSoftDeleteDiscount(x, baseUrl)) || [];
    return { putReqs: updateLikeSoftDelete, postAndDelreqs: toPost.concat(toDelete) };
  }

  private static postCustomerDiscount(discount: CustomerDiscountDTO, baseUrl: string): HttpBasicRequest {
    return new HttpBasicRequest({
      url: baseUrl + `/customer-discount`, method: 'post', body: {
        customerId: discount.customerId,
        validityDateFrom: new Date().toISOString(),
        storeId: discount.storeId,
        discount: discount.discount,
        type: discount.type,
        validityDateTo: null
      }
    });
  }

  private static updateLikeSoftDeleteDiscount(discount: CustomerDiscountDTO, baseUrl: string) {
    return new HttpBasicRequest({
      url: baseUrl + `/customer-discount/${discount.id}`, method: 'put', body: {
        validityDateTo: new Date(new Date().setSeconds(new Date().getSeconds() - 3)).toISOString()
      }
    });
  }

  private static deleteCustomerDiscount(discount: CustomerDiscountDTO, baseUrl: string): HttpBasicRequest {
    return new HttpBasicRequest({
      url: baseUrl + `/customer-discount/${discount.id}`, method: 'delete',
    });
  }

  public static CustomerVM(customer: CustomerFullDTO, storeList: Shop[], currentStoreId: number, insertCompanyFormInName?: boolean): CustomerVM {
    customer.acceptsOrders = customer.blockOrderType === BlockOrderTypeEnum.Open;
    return new CustomerVM({
      id: customer.id,
      vatNumber: customer.vatNumber,
      fullName: customer.name + (customer.vatNumber ? ' - ' + customer.vatNumber : ''),
      agency: '',
      city: customer.customerLocations?.find(l => l.locationType === LocationTypeEnum.BillingLocation)?.location.city,
      pointsOfSale: customer.pointsOfSale?.map(x => LocationMapper.PointOfSaleDetail(x, [], storeList, currentStoreId)) || [],
      name: (!insertCompanyFormInName || !customer.companyForm) ? customer.name : customer.name + ' ' + customer.companyForm.name,
      onlineStore: '',
      orders: '',
      tier: '',
      totalPurchased: '',
      externalId: customer.externalId,
      checkInStatus: customer.checkInStatus,
      billingLocation: customer.customerLocations?.find(l => l.locationType === LocationTypeEnum.BillingLocation)?.location,
      customerLocations: customer.customerLocations?.map(x => x.location) || [],
      customerVouchers: customer.customerVouchers,
      customerStatus: customer.blockOrderType !== BlockOrderTypeEnum.Open ? CheckInStatusEnum.CommercialBlocked : customer.checkInStatus
    });
  }

  public static CustomerVoucherVM(customer: CustomerVM, voucherId?: number): CustomerVoucherVM {
    return new CustomerVoucherVM({
      id: customer.id,
      vatNumber: customer.vatNumber,
      agency: '',
      city: customer.city,
      pointsOfSale: customer.pointsOfSale,
      name: customer.name,
      onlineStore: '',
      orders: '',
      tier: '',
      totalPurchased: '',
      checkInStatus: customer.checkInStatus,
      billingLocation: customer.billingLocation,
      customerVoucherExists: voucherId ? customer.customerVouchers.some(x => x.id === voucherId) : false,
      residualAmount: this.getResidualAmount(customer, voucherId)
    });
  }

  private static getResidualAmount(customer: CustomerVM, voucherId: number): string {
    if (voucherId) {
      const voucher = customer.customerVouchers.find(x => x.id === voucherId);
      if (voucher) {
        return `€${UtilityFunctions.NumberFromatting(voucher.residualAmount)} / €${UtilityFunctions.NumberFromatting(voucher.amount)}`;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  public static CustomerVMWhenCheck(customer: CustomerVM, isChecked: boolean = false): CustomerVMWhenCheck {
    return new CustomerVMWhenCheck({
      isChecked,
      id: customer.id,
      vatNumber: customer.vatNumber,
      agency: customer.agency,
      city: customer.city,
      pointsOfSale: customer.pointsOfSale,
      name: customer.name,
      onlineStore: customer.onlineStore,
      orders: customer.orders,
      tier: customer.tier,
      totalPurchased: customer.totalPurchased,
      checkInStatus: customer.checkInStatus
    });
  }

  public static RegisterCustomerCreateRequest(checkInData: CustomerCheckinVM, posDataArray: PointOfSaleDetailVM[], notUsePrefix: boolean = false, removeSpaceFromVat?: boolean): RegisterCustomerVM {
    var customer = this.CustomerDTO(checkInData, checkInData.companyInfo.checkInStatus, notUsePrefix, removeSpaceFromVat);
    // var billingLocationContacts: ContactVM[] = [];
    // billingLocationContacts = [...billingLocationContacts, ...checkInData.contactInfo.email];
    // billingLocationContacts = [...billingLocationContacts, ...checkInData.contactInfo.phoneNumber];
    // billingLocationContacts = [...billingLocationContacts, ...checkInData.contactInfo.social];
    // billingLocationContacts = [...billingLocationContacts, ...checkInData.contactInfo.webSite];

    var billingLocationContacts: ContactVM[] = checkInData.contactInfo;

    var pointsOfSale: CustomerRegistrationPOS[] = [];

    posDataArray.map(pos => {
      var posContacts: ContactVM[] = pos.contacts;

      // posContacts = [...posContacts, ...pos.contactList.email];
      // posContacts = [...posContacts, ...pos.contactList.phoneNumber];
      // posContacts = [...posContacts, ...pos.contactList.social];
      // posContacts = [...posContacts, ...pos.contactList.webSite];
      // posContacts = posContacts.map(x => new ContactVM({
      //   type: x.type,
      //   value: x.value
      // }));
      pointsOfSale.push(new CustomerRegistrationPOS({
        contacts: posContacts,
        location: pos.location,
        name: pos.name
      }));
    });

    return new RegisterCustomerVM({
      customer: customer,
      //paymentTermId: checkInData.paymentInfo.paymentTermId,
      //billingLocation: checkInData.companyInfo.location,
      billingLocationContacts: billingLocationContacts,
      customerCategoryIds: [checkInData.companyInfo.customerSelectedCategories[0]?.id],
      //pointsOfSale: pointsOfSale
    });
  }
}
